// Featured product images shown on the Home page (Product Gallery section).
const HomeProductImagesData = [
    {
        id: 1,
        title: "Cable Tray Systems",
        image: `${process.env.PUBLIC_URL}/images/products/product-1.webp`,
        alt: "Cable Tray Systems"
    },
    {
        id: 2,
        title: "Ladder Type Cable Trays",
        image: `${process.env.PUBLIC_URL}/images/products/product-2.webp`,
        alt: "Ladder Type Cable Trays"
    },
    {
        id: 3,
        title: "Cable Tray Cross Units",
        image: `${process.env.PUBLIC_URL}/images/products/product-4.webp`,
        alt: "Cable Tray Cross Units"
    },
    {
        id: 4,
        title: "GI Flats & Mounting Plates",
        image: `${process.env.PUBLIC_URL}/images/products/product-18.webp`,
        alt: "GI Flats & Mounting Plates"
    },
    {
        id: 5,
        title: "Solar Mounting Structures",
        image: `${process.env.PUBLIC_URL}/images/products/product-25.webp`,
        alt: "Solar Mounting Structures"
    },
    {
        id: 6,
        title: "Solar Mounting Clamps",
        image: `${process.env.PUBLIC_URL}/images/products/product-26.webp`,
        alt: "Solar Mounting Clamps"
    }
];

export default HomeProductImagesData;
